import { Component } from '@angular/core'

interface Invoice {
    chargeType: string;
    documentType: string;
    invoiceId: string;
    invoiceDate: Date;
    totalUsd: number;
  }
@Component({
    selector: 'app-awsinc',
    templateUrl: './awsinc.component.html',
    styleUrls: ['./awsinc.component.css',
        '../invoices.component.css'
    ]
})

export class AWSInc {
    searchTerm: string = '';
    sortColumn: keyof Invoice = 'chargeType';
    sortDirection: 'asc' | 'desc' = 'asc';
  
    invoices: Invoice[] = [
      {
        chargeType: 'Service Fee',
        documentType: 'Invoice',
        invoiceId: 'INV001',
        invoiceDate: new Date('2025-05-01'),
        totalUsd: 1000,
      },
      {
        chargeType: 'Usage Charge',
        documentType: 'Credit Note',
        invoiceId: 'INV002',
        invoiceDate: new Date('2025-04-15'),
        totalUsd: 500,
      },
      {
        chargeType: 'Subscription',
        documentType: 'Invoice',
        invoiceId: 'INV003',
        invoiceDate: new Date('2025-05-10'),
        totalUsd: 1500,
      },
      // Add more invoices here
    ];
  
    // Returns filtered and sorted invoices
    filteredInvoices(): Invoice[] {
      const filtered = this.invoices.filter((inv) =>
        (
          inv.chargeType.toLowerCase() +
          ' ' +
          inv.documentType.toLowerCase() +
          ' ' +
          inv.invoiceId.toLowerCase() +
          ' ' +
          inv.invoiceDate.toDateString().toLowerCase() +
          ' ' +
          inv.totalUsd.toString()
        ).includes(this.searchTerm.toLowerCase())
      );
  
      return filtered.sort((a, b) => {
        let valA = a[this.sortColumn];
        let valB = b[this.sortColumn];
  
        // Handle date sorting
        if (valA instanceof Date && valB instanceof Date) {
          valA = valA.getTime();
          valB = valB.getTime();
        }
  
        if (valA < valB) return this.sortDirection === 'asc' ? -1 : 1;
        if (valA > valB) return this.sortDirection === 'asc' ? 1 : -1;
        return 0;
      });
    }
  
    // Toggle sort column and direction
    sortBy(column: keyof Invoice) {
      if (this.sortColumn === column) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortColumn = column;
        this.sortDirection = 'asc';
      }
    }
}